<template>
    <div class="case-container">
        <div v-if="loading" style="margin:0 auto">
            <Spinner size="large" message="Loading..." line-fg-color="#000" style="padding: 5rem 0;"/>
        </div>
        <div v-else-if="nodatafound">
            Sorry, we can't found your data, please try to access another page.
        </div>
        <div v-else class="case">
            <HeroBlock
                section-title="Case Study"
                v-if="data.company_name"
                :title="data.company_name"
                :content="data.short_description"
                :imgURL="data.hero_image.data.full_url"
                :border="false"
            />
            <ContentBlock
                v-if="data.section_1_title"
                :title="data.section_1_title"
                :content="data.section_1_content"
                :img="data.section_1_image.data.full_url"
                :reverse="true"
                :button="false"
                :border="false"
                style="margin-top: 0"
            />
            <ContentBlock
                v-if="data.section_2_title"
                :title="data.section_2_title"
                :content="data.section_2_content"
                :img="data.section_2_image.data.full_url"
                :button="false"
                :border="false"
            />
            <ContentBlock
                v-if="data.section_3_title"
                :title="data.section_3_title"
                :content="data.section_3_content"
                :img="data.section_3_image.data.full_url"
                :reverse="true"
                :button="false"
                :border="false"
            />
            <AudienceBlock
                v-if="data.special_section_stat_1"
                :title="data.special_section_title"
                :subtitle="data.special_section_content"
                :stat1-number="data.special_section_stat_1"
                :stat1-title="data.special_section_stat_title_1"
                :stat2-number="data.special_section_stat_2"
                :stat2-title="data.special_section_stat_title_2"
                :stat3-number="data.special_section_stat_3"
                :stat3-title="data.special_section_stat_title_3"
                :imgURL="data.special_section_image ? data.special_section_image.data.full_url : ''"
            />
            <ContentBlock
                v-if="data.section_4_title"
                :title="data.section_4_title"
                :content="data.section_4_content"
                :img="data.section_4_image.data.full_url"
                :button="false"
                :border="false"
            />
            <div v-if="data.image_section_1" class="image_section">
                <img :src="data.image_section_1.data.full_url">
            </div>
            <div v-if="data.image_section_2" class="image_section">
                <img :src="data.image_section_2.data.full_url">
            </div>
            <div v-if="data.image_section_3" class="image_section">
                <img :src="data.image_section_3.data.full_url">
            </div>
            <div v-if="data.image_section_4" class="image_section">
                <img :src="data.image_section_4.data.full_url">
            </div>
            <div v-if="data.image_section_5" class="image_section">
                <img :src="data.image_section_5.data.full_url">
            </div>
            <div v-if="data.image_section_6" class="image_section">
                <img :src="data.image_section_6.data.full_url">
            </div>
            <div v-if="data.image_section_7" class="image_section">
                <img :src="data.image_section_7.data.full_url">
            </div>
            <div v-if="data.image_section_8" class="image_section">
                <img :src="data.image_section_8.data.full_url">
            </div>
            <div v-if="data.image_section_9" class="image_section">
                <img :src="data.image_section_9.data.full_url">
            </div>
            <div v-if="data.image_section_10" class="image_section">
                <img :src="data.image_section_10.data.full_url">
            </div>
            <Testimonial
                v-if="data.testimonials && !data.testimonials_with_photo"
                :slides="JSON.parse(data.testimonials)"
            />
            <Testimonial
                v-if="data.testimonials && data.testimonials_with_photo"
                :slides="JSON.parse(data.testimonials)"
            />
            <ContentBlock
                v-if="data.video_section_title"
                :title="data.video_section_title"
                :content="data.video_section_content"
                :video="data.video_section_url"
                :reverseMobile="true"
                :button="false"
                :border="false"
                :reverse="false"
                :vimeoVideo="data.vimeo_video_url"
            />
            <div v-if="data.section_5_title"  class="container">
                <div v-if="data.section_5_title" class="section-block">
                    <h2 class="title">
                        {{data.section_5_title}}
                    </h2>
                    <p v-html="data.section_5_content">

                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HeroBlock from '../components/HeroBlock';
import ContentBlock from '../components/ContentBlock';
import Testimonial from '../components/Testimonial';
import AudienceBlock from '../components/AudienceBlock';
import Spinner from 'vue-simple-spinner'

export default {
    name: "Case",
    components: {
        ContentBlock,
        Testimonial,
        AudienceBlock,
        HeroBlock,
        Spinner
    },
    mounted:function(){
        this.axios.get(`https://api.uptowncreative.io/_/items/uptowncreative?filter[slug][eq]=${this.$route.params.slug}&fields=*.*`)
        .then((response) => {
            if(response.data.data.length > 0){
                this.data = response.data.data[0]
            }else{
                this.nodatafound = !this.nodatafound;
            }
            if(this.data.page_title){
                this.page_title = this.data.page_title;
            }
            if(this.data.page_description){
                this.page_description = this.data.page_description;
            }
            this.loading = false;
        })
    },
    metaInfo() {
         const data = this.page_title; 
         const content = this.page_description
         return {
             title: data,
             meta: [{
                name: 'description', 
                content: content
            }]
         }
    },
    watch: {
        $route(to) {
            if (to.params.slug !== undefined){
                this.axios.get(`https://api.uptowncreative.io/_/items/uptowncreative?filter[slug][eq]=${this.$route.params.slug}&fields=*.*`)
                .then((response) => {
                    if(response.data.data.length > 0){
                        this.data = response.data.data[0]
                    }else{
                        this.nodatafound = !this.nodatafound
                    }
                    if(this.data.page_title){
                        this.page_title = this.data.page_title
                    }
                    if(this.data.page_description){
                        this.page_description = this.data.page_description
                    }
                    this.loading = false;
                })
            }
        },
    },
    data(){
        return{
            page_title: 'Case Study | Uptown Creative',
            page_description: 'Uptown Creative',
            loading: true,
            nodatafound: false,
            data: undefined,
        }
    },
}   
</script>

<style lang="scss" scoped>
.image_section{
    img{
        display: block;
        width: 100%;
    }
}
.section-block{
    text-align: center;
    max-width: 950px;
    margin: 103px auto;
}

@media (max-width: $mobile) { 
    .image_section{
        margin: 1rem 0;
    }
}

</style>